/**
 * GPT-SoVITS TTS Provider
 * Extracted and adapted from Phantasy AudioService
 */

import { BaseTTSProvider } from './ITTSProvider';
import { createLogger } from '../../utils/logger';
import type { TTSProviderConfig } from '../../types/config';

export class GPTSoVITSProvider extends BaseTTSProvider {
  private logger: ReturnType<typeof createLogger>;

  constructor(config: TTSProviderConfig) {
    super(config);
    this.logger = createLogger('GPTSoVITSProvider');
  }

  getProviderName(): string {
    return 'gptsovits';
  }

  async generateAudio(text: string): Promise<Blob> {
    try {
      this.logger.info('GPT-SoVITS generating audio for text:', text);

      const cleanedText = this.validateText(text);
      this.logger.debug('Cleaned text:', cleanedText);

      const params = new URLSearchParams({
        text: cleanedText,
        text_lang: this.config.textLang || 'en',
        ref_audio_path: this.config.refAudioPath || 'audio/premade/10000-rally.wav',
        prompt_lang: this.config.promptLang || 'en',
        prompt_text: this.config.promptText || 'Hello, I am Phantasy, your AI companion.',
        text_split_method: this.config.textSplitMethod || 'cut5',
        batch_size: (this.config.batchSize || 1).toString(),
        media_type: this.config.mediaType || 'wav',
        streaming_mode: (this.config.streamingMode || false).toString(),
        speed: (this.config.speed || 1.0).toString(),
      });

      const url = `${this.config.apiUrl || 'http://localhost:9880'}?${params.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'audio/wav',
        },
      });

      if (!response.ok) {
        throw new Error(`GPT-SoVITS HTTP error! status: ${response.status}`);
      }

      const arrayBuffer = await response.arrayBuffer();
      this.logger.info('GPT-SoVITS audio generated successfully');
      return new Blob([arrayBuffer], { type: 'audio/wav' });

    } catch (error) {
      this.logger.error('Error in GPT-SoVITS generation:', error);
      throw error;
    }
  }
}